import React from 'react';
import LogoHeader from '../components/LogoHeader';
import ProgressNav from '../components/ProgressNav';

const IntroProductNav = () => {
  const introProductSteps = [
    { title: 'Checkout', url: '/checkout' },
    { title: 'Shipping', url: '/gtb-thank-you/shipping' },
    { title: 'Survey', url: '/personal-survey' },
    { title: 'Done', url: null },
  ];

  return (
    <>
      <LogoHeader />
      <ProgressNav steps={introProductSteps} />
    </>
  );
};

export default IntroProductNav;
